<script>
import ElTabs from 'element-ui/packages/tabs/src/tabs'

/**
 * 直接继承 Element Tabs，避免普通包装组件隔断 ElTabPane 对直接父级的依赖。
 * 统一样式类在根 VNode 上追加，业务页面仍只使用 UiTabs。
 */
export default {
  name: 'UiTabs',
  extends: ElTabs,
  props: {
    variant: { type: String, default: '', validator: value => ['', 'open-edges'].includes(value) }
  },
  render (h) {
    const vnode = ElTabs.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-tabs', { 'ui-tabs--open-edges': this.variant === 'open-edges' }]
    return vnode
  }
}
</script>
